const TRUSTED_HOSTS = new Set([
  'ably.com',
  'support.ably.com',
  'knowledge.ably.com',
  'faqs.ably.com',
  'press.ably.com',
  'go.ably.com',
]);

const isTrustedTarget = (target: string): boolean => {
  try {
    const url = new URL(target, window.location.origin);
    if (url.origin === window.location.origin) return true;

    return url.protocol === 'https:' && TRUSTED_HOSTS.has(url.hostname);
  } catch {
    return false;
  }
};

export const resolveRedirectTarget = (
  response: Response,
  body: { location?: string; redirect?: string } | null,
  fallback: string,
): string => {
  const target = response.headers.get('location') || body?.location || body?.redirect;
  if (!target) return fallback;

  if (!isTrustedTarget(target)) {
    window.Sentry?.captureMessage('Auth redirect target rejected as untrusted', {
      level: 'warning',
      extra: { target },
    });
    return fallback;
  }

  return target;
};
